module.exports = __webpack_public_path__ + "assets/img/offie-hero-bg.f3e14afa.svg";